import { MutationTree } from "vuex";
import Vue from "vue";

import demandTypesStore from "./demand-types.store";
import { IDemandEditState } from "./states.store";
import { IDemandModel } from "../../../models/demand";

const mutations: MutationTree<IDemandEditState> = <MutationTree<IDemandEditState>>{
  [demandTypesStore.Set.ASSIGNVALUE]: (
    state: IDemandEditState,
    demand: IDemandModel
  ) => {
    Object.keys(demand).forEach(key => Vue.set(state.demand, key, demand[key]));
  },

  [demandTypesStore.Set.DEMAND]: (
    state: IDemandEditState,
    demand: IDemandModel
  ) => {
    state.demand = demand;
  },

  [demandTypesStore.Set.DEMANDORIGIN]: (
    state: IDemandEditState,
    demand: IDemandModel
  ) => {
    state.demandOrigin = demand;
  },

  [demandTypesStore.Set.UPDATE_DEMANDORIGIN]: (
    state: IDemandEditState,
    demand: IDemandModel
  ) => {
    Object.keys(demand).forEach(key => Vue.set(state.demandOrigin, key, demand[key]));
  },
  
  [demandTypesStore.Set.DEMAND_FOR_CREATING]: (
    state: IDemandEditState,
    demand: IDemandModel
  ) => {
    state.demandForCreate = demand;
  },
};

export default mutations;
